import useMediaView from "features/common/hooks/useMediaView";
import React, { createContext, useCallback, useEffect, useState } from "react";
import TagDetailEditWebPage from "./(web)/TagDetailEditWebPage";
import useBeforeUnload from "features/common/hooks/useBeforeUnload";
import SaveWarningModal from "pages/user/dashboard/detail/SaveWarningModal";
import TagDetailEditMobilePage from "./(mobile)/TagDetailEditMobilePage";
import { useParams } from "react-router-dom";
import useTagsDetailQuery from "features/tag/hooks/queries/useTagsDetailQuery";
import { useDocumentClassesByCategoryQuery } from "features/document/hooks/queries/useDocumentClassesByCategoryQuery";

interface DirtyContextType {
  isDirty: boolean;
  markDirty: () => void;
  resetDirty: () => void;
}

export const DirtyContext = createContext<DirtyContextType | null>(null);

const TagDetailEditPage = () => {
  const isSmall = useMediaView("small");
  const {
    isBlock,
    blocking,
    process,
    enableUnloadTracking,
    disableUnloadTracking,
  } = useBeforeUnload({
    isInitialTracking: false,
  });
  const { id } = useParams();
  if (!id) {
    throw new Error("id is required");
  }
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const markDirty = useCallback(() => setIsDirty(true), []);
  const resetDirty = useCallback(() => setIsDirty(false), []);

  const { data } = useTagsDetailQuery(id);

  const { data: documentClasses } = useDocumentClassesByCategoryQuery(id);

  useEffect(() => {
    isDirty && enableUnloadTracking();
  }, [enableUnloadTracking, isDirty]);

  return (
    <DirtyContext.Provider value={{ isDirty, markDirty, resetDirty }}>
      {
        <SaveWarningModal
          isOpen={isBlock}
          onCancel={blocking}
          onConfirm={process}
        />
      }
      {!isSmall && (
        <TagDetailEditWebPage
          docCategoryUuid={id}
          data={data.data.result}
          documentClasses={documentClasses}
          disableUnloadTracking={disableUnloadTracking}
        />
      )}
      {isSmall && (
        <TagDetailEditMobilePage
          docCategoryUuid={id}
          data={data.data.result}
          documentClasses={documentClasses}
          disableUnloadTracking={disableUnloadTracking}
        />
      )}
    </DirtyContext.Provider>
  );
};

export default TagDetailEditPage;
